import React from "react";
import { Theme } from "../../theme";

export const SearchIcon = ({ fill, ...props }) => {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="19.998"
            viewBox="0 0 20 19.998"
        >
            <path
                d="M956.249,1597.777l-4.717-5.783a8.5,8.5,0,0,0-.8-11.035,8.453,8.453,0,1,0-.875,12.728l5.791,4.692a.425.425,0,0,0,.6-.6Zm-6.81-6.156a6.618,6.618,0,1,1,0-9.361A6.647,6.647,0,0,1,949.439,1591.621Z"
                transform="translate(-936.353 -1578.484)"
                fill={fill ? fill : Theme.colors.blue}
            />
        </svg>
    );
};
